import { Role } from '@/generated/graphql';
import { useAuth } from '@/hooks/useAuth';
import { useMonetizationEnabled } from '@/hooks/useMonetizationEnabled';
import {
  SCREENS_ROUTE,
  ACCOUNT_ROUTE,
  PRICING_ROUTE,
  SUPPORT_ROUTE,
  SIGNUP_ROUTE,
  LOGIN_ROUTE,
} from '@/routes/consts';
import {
  AvatarIcon,
  DesktopIcon,
  QuestionMarkCircledIcon,
} from '@radix-ui/react-icons';
import { NavLink } from 'react-router-dom';
import { Logo } from './Logo';
import { useTranslation } from '@/i18n';

const activeClassName = 'font-bold text-foreground hover:text-foreground';

export function AppNav() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { monetizationEnabled } = useMonetizationEnabled();
  return (
    <header data-name="APP_NAV" className="w-full">
      <div className="flex justify-center">
        <div className="flex h-14 w-full items-center gap-2 md:gap-4">
          <div className="mx-4 flex w-full justify-between md:flex">
            <div data-name="LEFT_SECTION" className="flex items-center gap-2">
              <a
                data-name="BRAND_LOGO"
                className="mx-2 flex items-center gap-2 lg:mr-6"
                href="/"
              >
                <Logo size="xs" />
                <span className="relative top-[0.1rem] hidden font-heading text-4xl md:inline-block">
                  HappiScreen
                </span>
              </a>
            </div>
            <div data-name="RIGHT_SECTION" className="flex items-center gap-8">
              <div className="flex items-center gap-8">
                {user && (
                  <>
                    {(user.role === Role.User || user.role === Role.Admin) && (
                      <NavLink
                        to={SCREENS_ROUTE}
                        className={({ isActive }) =>
                          `inline-flex items-center gap-1 text-sm ${
                            isActive ? activeClassName : ''
                          }`
                        }
                        title={t('nav.myScreens')}
                      >
                        <DesktopIcon className="size-6" />
                        {/* <span>{t('nav.myScreens')}</span> */}
                      </NavLink>
                    )}
                    <NavLink
                      to={ACCOUNT_ROUTE}
                      className={({ isActive }) =>
                        `inline-flex items-center gap-1 text-sm ${
                          isActive ? activeClassName : ''
                        }`
                      }
                      title={t('nav.myAccount')}
                    >
                      <AvatarIcon className="size-6" />
                      {/* <span>{t('nav.myAccount')}</span> */}
                    </NavLink>
                  </>
                )}
                {!user && (
                  <>
                    {/* sign up */}
                    <NavLink
                      to={SIGNUP_ROUTE}
                      className={({ isActive }) =>
                        `inline-flex items-center gap-1 text-sm ${
                          isActive ? activeClassName : ''
                        }`
                      }
                      title={t('nav.signUp')}
                    >
                      <span>{t('nav.signUp')}</span>
                    </NavLink>
                    {/* login  */}
                    <NavLink
                      to={LOGIN_ROUTE}
                      className={({ isActive }) =>
                        `inline-flex items-center gap-1 text-sm ${
                          isActive ? activeClassName : ''
                        }`
                      }
                      title={t('nav.login')}
                    >
                      <span>{t('nav.login')}</span>
                    </NavLink>
                    {monetizationEnabled && (
                      <NavLink
                        to={PRICING_ROUTE}
                        className={({ isActive }) =>
                          `inline-flex items-center gap-1 text-sm ${
                            isActive ? activeClassName : ''
                          }`
                        }
                        title={t('nav.pricing')}
                      >
                        <span>{t('nav.pricing')}</span>
                      </NavLink>
                    )}
                  </>
                )}
                <NavLink
                  to={SUPPORT_ROUTE}
                  className={({ isActive }) =>
                    `inline-flex items-center gap-1 text-sm ${
                      isActive ? activeClassName : ''
                    }`
                  }
                  title={t('nav.support')}
                >
                  <QuestionMarkCircledIcon className="size-6" />
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
